import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import styles from "./InvoiceDiscountDialog.module.scss";
import InputGroup from "../../core/InputGroup";
import { InvoiceContentRequest } from "../../../apis/models/InvoiceContentRequest";
import { BrandlistResponseData } from "../../../apis/models/BrandlistResponse";
import { InvoiceMasterData } from "../../../apis/models/InvoiceMasterRequest";
import { format } from "date-fns";

const InvoiceDiscountDialog: React.FC<InvoiceDiscountDialogProps> = (props: InvoiceDiscountDialogProps) => {
    const {open, onClose, onSave, targetBrand, targetInvoice} = props;
    const initialItem: InvoiceContentRequest = {
      invoiceMasterId: "",
      name: "",
      totalPrice: 0,
      description: "",
      order: 0
    }
    const [dialogData, setDialogData] = React.useState<InvoiceContentRequest[]>([initialItem]);


    const handleInputChange = (item: InvoiceContentRequest, index: number) => {
        const copyData = [...dialogData];
        copyData.splice(index, 1, item);
        setDialogData(copyData);
    }

    const deleteItem = (item: number) => {
        const copyData = [...dialogData];
        copyData.splice(item, 1);
        setDialogData(copyData);
    }
    
    const invoicePeriod = React.useMemo(() => {
      if (targetInvoice){
        return `${format(new Date(targetInvoice.from), "yyyy/MM/dd")} ～ ${format(new Date(targetInvoice.to), "yyyy/MM/dd")}`
      }
      return ''
    }, [targetInvoice])

    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="sm">
            <DialogTitle sx={{fontWeight: 700, fontSize: "24px", paddingBottom: "40px"}}>{targetBrand?.brandName ?? ''} - 割引項目追加</DialogTitle>
            <DialogContent sx={{padding: "0 40px 24px"}}>
                <div className={styles.dialog__label}>
                  <span>請求期間：</span>
                  <span className={styles.dialog__label_content}>{invoicePeriod}</span>
                </div>
                <div className={styles.dialog__content}>
                  {
                    dialogData.map((item, index) => (
                      <div className={styles.dialog__content_row} key={index}>
                          <InputGroup label="品名" required type="text" onChange={(val) => handleInputChange({...item, name: val}, index)} value={item.name}/>
                          <InputGroup label="割引額(税抜)" required type="number" onChange={(val) => handleInputChange({...item, totalPrice: Number(val)}, index)} value={item.totalPrice < 0 ? item.totalPrice : -item.totalPrice}/>
                          <InputGroup label="摘要" type="text" onChange={(val) => handleInputChange({...item, description: val}, index)} value={item.description}/>
                          <CloseIcon className={styles.dialog__content_row_icon} onClick={() => deleteItem(index)}/>
                      </div>
                    ))
                  }
                </div>
                <div className={styles.dialog__add}>
                    <Button variant="outlined" color="primary" onClick={() => {setDialogData([...dialogData, initialItem])}}>＋行追加</Button>
                </div>
                <div className={styles.dialog__functions}>
                    <Button variant="outlined" color="primary" onClick={() => {setDialogData([initialItem]); onClose()}}>キャンセル</Button>
                    <Button 
                        variant="contained" color="primary" onClick={() => {onSave(dialogData); onClose()}} 
                        disabled={!dialogData.every(item => item.name !== "" && item.totalPrice !== 0)}
                    >登録</Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default InvoiceDiscountDialog;

export type InvoiceDiscountDialogProps = {
    open: boolean,
    onClose: () => void,
    onSave: (val: InvoiceContentRequest[]) => void,
    targetBrand?: BrandlistResponseData,
    targetInvoice?: InvoiceMasterData,
}